module.exports = __webpack_public_path__ + "static/media/infoFiscal.0e074ced.png";